import { loadStoreLogo } from "../data-resolver/headerlogo";
const state = () => ({

    storeLogo: null,
});
const actions = {
    /**
 * Load the dynamic logo
 *
 */

    async loadStoreLogo({ commit }) {
        const logo  = await loadStoreLogo();
        commit("setStoreLogo", logo );
    },
}
const mutations = {

    setStoreLogo(state, payload) {
        state.storeLogo = payload;
    }
};
const getters = {

    getStoreLogo: (state) => state.storeLogo,
};

// export this module.
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
